import { Component, OnInit } from '@angular/core';
import { GAccsessService } from 'src/app/services/g-accsess.service';
import { UnitsService } from 'src/app/services/units.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GatesService } from 'src/app/services/gates.service';
import { DatePipe } from '@angular/common';
import { OpreatorsService } from 'src/app/services/opreators.service';
import { PageEvent } from '@angular/material/paginator';
import { MainService } from 'src/app/services/main.service';

@Component({
  selector: 'app-oprreators-list',
  templateUrl: './oprreators-list.component.html',
  styleUrls: ['./oprreators-list.component.css']
})
export class OprreatorsListComponent implements OnInit {
  filter_form: FormGroup | any;
  all_gates: any
  all_types: any
  curent_page = 1
  pagesLength = 1
  pageNumber = 0
  pageLimt = 100
  pipe = new DatePipe('en-US');
  opreators_logs: any = []

  constructor(private rest: OpreatorsService,
    private unitServ: UnitsService,
    private formBuilder: FormBuilder,
    private mainServ : MainService,
    private gateServ: GatesService) { }

  ngOnInit() {
    this.initFormFilet()
    this.retriveOpreatorsLog()
  }

  initFormFilet() {
    this.filter_form = this.formBuilder.group({
      email: [''],
      operator_name: [''],
      valid_to: [''],
      valid_from: [''],
    });
  }
  retriveOpreatorsLog(value?: any) {
    let data: any
    if (value) {
      Object.keys(value).forEach(key => {
        if (value[key] === '' || value[key] === null) {
          delete value[key];
        }
      });
      value.page = this.curent_page
      value.page_limit = this.pageLimt
      data = value
      console.log(data)
    } else {
      console.log("in logs")
      data = {
        page: this.curent_page,
        page_limit: this.pageLimt,
      }
    }

    this.rest.retiveLogs(data).subscribe((res: any) => {
      console.log("hh", res)
      this.opreators_logs = res.operator_logs
      this.pagesLength = res.total_number
    })
  }

  filterData() {
    let data = this.filter_form.value
    data.valid_from = this.pipe.transform(data.valid_from, 'YYYY-MM-dd');
    data.valid_to = this.pipe.transform(data.valid_to, 'YYYY-MM-dd');
    this.retriveOpreatorsLog(data)
  }

  exportData() {
    let data = this.filter_form.value
    data.valid_from = this.pipe.transform(data.valid_from, 'YYYY-MM-dd');
    data.valid_to = this.pipe.transform(data.valid_to, 'YYYY-MM-dd');

    Object.keys(data).forEach(key => {
      if (data[key] === '' || data[key] === null) {
        delete data[key];
      }
    });
    data.page = this.curent_page
    data.page_limit = this.pageLimt
    console.log(data)
    this.rest.exportLogs(data).subscribe((res:any) => {
      console.log(res)
      if(res){
        window.open(`res`, '_blank');
      }else {
        this.mainServ.erorrToast('No data Found')
      }
    })
}

resetForm(){
  this.filter_form.reset()
  this.retriveOpreatorsLog()
}

handlePageEvent(e: PageEvent) {
  this.pageNumber = e.pageIndex
  this.curent_page = e.pageIndex + 1
  this.pageLimt = e.pageSize
  this.retriveOpreatorsLog()
  console.log(e)
}
}
